import { z } from "zod/v4";
import { nuqsBoolean, nuqsCommaArray } from "#/modules/util.pagination/search.nuqs";

// Search params schema for klassen insights: class/date-range filters, progress toggles,
// leerlijn filter, and per-class activity selection.

export const insightsSearchSchema = z.object({
  klasId: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  includeWithProgress: nuqsBoolean(true),
  includeWithPartialProgress: nuqsBoolean(true),
  includeWithoutProgress: nuqsBoolean(true),
  includeWithDefaults: nuqsBoolean(true),
  includeWithCustom: nuqsBoolean(true),
  selectedLeerlijnFilterIds: nuqsCommaArray,
  selectedBeweegactiviteitenByKlas: z.record(z.string(), z.array(z.string())).catch({}),
});

export type KlasBeweegactiviteitenFilters = z.infer<typeof insightsSearchSchema>;

type InsightsSearchDefaults = Pick<
  KlasBeweegactiviteitenFilters,
  | "includeWithProgress"
  | "includeWithPartialProgress"
  | "includeWithoutProgress"
  | "includeWithDefaults"
  | "includeWithCustom"
  | "selectedLeerlijnFilterIds"
  | "selectedBeweegactiviteitenByKlas"
>;

/** Defaults stripped from the URL by `stripSearchParams`. */
export const INSIGHTS_SEARCH_DEFAULTS: InsightsSearchDefaults = {
  includeWithProgress: true,
  includeWithPartialProgress: true,
  includeWithoutProgress: true,
  includeWithDefaults: true,
  includeWithCustom: true,
  selectedLeerlijnFilterIds: [],
  selectedBeweegactiviteitenByKlas: {},
};
